<style src="./style.scss" global>

</style>

<Router>
  <Route path="/" exact let:router component={Home}></Route>
  <Route path="/clase-gratis" exact let:router component={Clases}></Route>
  <Route path="/signup/" let:router component={SignUp}></Route>
  <Route path="/my-account/" let:router component={MyAccount}></Route>
  <Route path="/recover/" let:router component={RecoverPassword}></Route>
  <Route path="/terminos-y-condiciones/" let:router component={Terminos}></Route>
  <Route path="/politicas-de-privacidad/" let:router component={Politicas}></Route>
  <Route path="/unete-a-nuestro-equipo/" let:router component={Unete}></Route>
  <Route path="/contacto/" let:router component={Contacto}></Route>
  <Route path="/checkout/:item" let:router component={Checkout}></Route>
  <Route path="/success/:sessionId" let:router component={CheckoutSuccess}></Route>
  <Route path="/clases/" let:router component={Clases}></Route>
  <Route path="/clases/:categorySlug" let:router component={Clases}></Route>
  <Route path="/instructores/" let:router component={Team}></Route>
  <Route path="/instructores/:name" let:router component={Instructores}></Route>
  <Route path="/session/:sessionId" let:router component={Session}></Route>
  <Route path="/nuestro-reproductor" let:router component={Faq}></Route>
  <Route fallback component={Home}></Route>
</Router>

<script>
  import {Router, Route, Link} from 'yrv';
  import Home from '@Pages/Home/index.svelte';
  import MyAccount from '@Pages/MyAccount/index.svelte';
  import RecoverPassword from '@Pages/RecoverPassword/index.svelte';
  import SignUp from '@Pages/SignUp/index.svelte';
  import Terminos from '@Pages/Terminos/index.svelte';
  import Politicas from '@Pages/Politicas/index.svelte';
  import Contacto from '@Pages/Contacto/index.svelte';
  import Unete from '@Pages/Unete/index.svelte';
  import Checkout from '@Pages/Checkout/index.svelte';
  import CheckoutSuccess from '@Pages/CheckoutSuccess/index.svelte';
  import Clases from '@Pages/Clases/index.svelte';
  import Team from '@Pages/Team/index.svelte';
  import Instructores from '@Pages/Instructores/index.svelte';
  import Session from '@Pages/Session/index.svelte';
  import Faq from '@Pages/Faq/index.svelte';

  Router.hashchange = false;
</script>
